export enum ANALYSIS_TYPES {
  BAR_CHART = '01',
  PIE_CHART = '02',
  CARD = '03',
  LINE_CHART = '04',
  BAR_CHART_LEG = '05',
}
